import { memo, type SVGAttributes } from 'react';

const svgModules = import.meta.glob('/feather/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

interface FeatherIconProps extends SVGAttributes<SVGSVGElement> {
  name: string;
  size?: number | string;
}

// One markup object per icon + size: React 19 re-applies dangerouslySetInnerHTML
// whenever the object changes, so a fresh object re-parsed every icon on every render.
const markup = new Map<string, { __html: string }>();
function markupFor(name: string, size: number | string): { __html: string } | null {
  const id = `${name}:${size}`;
  let html = markup.get(id);
  if (!html) {
    const raw = svgModules[`/feather/${name}.svg`];
    if (!raw) return null;
    html = { __html: raw.replace(/<svg /, `<svg width="${size}" height="${size}" `) };
    markup.set(id, html);
  }
  return html;
}

export const FeatherIcon = memo(function FeatherIcon({ name, size = 20, className = '', style, ...rest }: FeatherIconProps) {
  const html = markupFor(name, size);

  if (!html) {
    return null;
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${className}`}
      style={{ width: size, height: size, ...style }}
      dangerouslySetInnerHTML={html}
      {...(rest as any)}
    />
  );
});
